import request, { type ApiResponse } from "@/utils/request";

export const getStepflowList = (
  params: { batchId: string; doorCode: string; workflow: string; name: string | null; taskId: string }
): Promise<ApiResponse<any>> => {
  return request.post("/app/activiti/stepflow/list", params);
}

export const getDoorObserverList = (params: any): Promise<ApiResponse<any>> => {
  return request.post('/app/door/observer/list', params);
}